import React from 'react';
import { AlertTriangle } from 'lucide-react';
import ThemedCard from '../../themed/ThemedCard';

interface PlanUsageBarProps {
  current: number;
  max: number | null;
  label: string;
}

export const PlanUsageBar: React.FC<PlanUsageBarProps> = ({ current, max, label }) => {
  if (max === null) return null;

  const percentage = Math.min((current / max) * 100, 100);
  const isWarning = percentage >= 80;
  const isFull = percentage >= 100;

  const barColor = isFull
    ? 'bg-rose-500'
    : isWarning
      ? 'bg-rose-400'
      : 'bg-rose-300';

  const textColor = isFull
    ? 'text-rose-600'
    : isWarning
      ? 'text-rose-500'
      : 'text-wedding-text-body';

  return (
    <ThemedCard className="p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-wedding-text-title">{label}</span>
        <span className={`text-sm font-semibold ${textColor}`}>
          {current} / {max}
        </span>
      </div>
      <div className="w-full bg-rose-100 rounded-full h-2">
        <div
          className={`${barColor} h-2 rounded-full transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {isFull && (
        <div className="flex items-center gap-1 mt-2 text-rose-600 text-sm">
          <AlertTriangle className="h-4 w-4" />
          <span>已達上限，建議升級方案或手動關閉接受提交</span>
        </div>
      )}
    </ThemedCard>
  );
};
